module.exports = __webpack_public_path__ + "media/images/icon-creation@3x-800a1906fea7d8134c7cb45ba3c853ac.png";